import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async getSiteConfig ({ commit, dispatch }) {
    try {
      const { data } = await directus.getItem('site_config', 1)
      commit('setAttr', {
        name: 'siteConfig',
        value: data
      })

      dispatch('set', 'siteConfig')
    } catch (err) {
      errorDirectus(err, dispatch)
    }
  }
}
